module.exports = __webpack_public_path__ + "img/wild_table.d1b913aa.png";